export const options = {
  pageLength: 10,
  deferLoading: 50,
  paging: true,
  select: true,
  autoWidth: true,
  serverSide: true,
  processing: true,
  scrollX: true,
  fixedColumns: {
    start: 2,
  },
  order: [],
  columnDefs: [{ targets: "_all", orderable: true }],
  lengthMenu: [5, 10, 20, 40, 80, 160, 200, 500, 1000, 5000, 10000],
  pagingType: "simple_numbers",
  language: {
    lengthMenu: "Show _MENU_ entries",
    paginate: {
      next: "Next",
      previous: "Previous",
    },
    info: "Showing _START_ to _END_ of _TOTAL_ entries",
  },
  dom:
    "<'row'<'col-sm-12 col-md-6 pb-3'l><'col-sm-12 col-md-6 pb-3'f>>" +
    "<'row'<'col-sm-12'B>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 d-flex justify-content-end'p>>",
};

export const columns = [
  { title: "TAG", data: "tag", className: "fixed-column-devices-table-bg" },
  { title: "IMEI", data: "imei", className: "fixed-column-devices-table-bg" },
  { title: "ICCID", data: "iccid" },
  { title: "MSISDN", data: "msisdn" },
  {
    title: "CLASS",
    data: "device_class",
    defaultContent: "",
    render: function (data, type, row) {
      return row.device_class?.name
        ? row.device_class.name
        : row.device_class
        ? row.device_class
        : "";
    },
  },
  {
    title: "TYPE",
    data: "device_type",
    defaultContent: "",
    render: function (data, type, row) {
      return row.device_type?.name
        ? row.device_type.name
        : row.device_type
        ? row.device_type
        : "";
    },
  },
  {
    title: "COURSE",
    data: "course.name",
    defaultContent: "",
    render: function (data, type, row) {
      return row.course?.name
        ? row.course.name
        : row.course_name
        ? row.course_name
        : "";
    },
  },
  { title: "SERVER LASTFIX", data: "server_lastfix", defaultContent: "" },
  { title: "SF VERSION", data: "sf_app_version", defaultContent: "" },
  {
    title: "TM VERSION",
    data: "sf_tagmarshal_app_version",
    defaultContent: "",
  },
  { title: "SF LAST CONNECTED", data: "sf_last_seen", defaultContent: "" },
  { title: "LAST FIX", data: "last_fix", defaultContent: "" },
  { title: "LOCKED", data: "sf_locked", defaultContent: "" },
  { title: "BATTERY", data: "battery", defaultContent: "" },
  { title: "POD STATUS", data: "pod_status", defaultContent: "" },
  { title: "POD DATA USED MB", data: "pod_data_used", defaultContent: "" },
  {
    title: "POD LAST CONNECTION",
    data: "pod_last_connection",
    defaultContent: "",
  },
  { title: "POD PRODUCT NAME", data: "pod_product_name", defaultContent: "" },
  {
    title: "PROVIDER",
    data: "provider.name",
    defaultContent: "",
    render: function (data, type, row) {
      return row.provider?.name
        ? row.provider.name
        : row.provider
        ? row.provider
        : "";
    },
  },
];

export const archivedDevicesColumns = [
  {
    title: "COURSE NAME",
    data: "course_name",
    className: "fixed-column-devices-table-bg",
  },
  { title: "TAG", data: "tag", className: "fixed-column-devices-table-bg" },
  { title: "IMEI", data: "imei" },
  { title: "ICCID", data: "iccid" },
  { title: "DELETED AT", data: "deleted_at" },
];
